import { RuntimeException1r3t0zl97011n as RuntimeException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloExceptionClass;
function ApolloException() {
  if (ApolloExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static k4d(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.qd(message, cause);
        captureStack($this, $this.j4d_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloException');
    ApolloExceptionClass = $;
  }
  return ApolloExceptionClass;
}
var ApolloOfflineExceptionClass;
function ApolloOfflineException() {
  if (ApolloOfflineExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor() {
        return new.target.p4d();
      }
      static p4d() {
        var $this = this.k4d('The device is offline');
        captureStack($this, $this.o4d_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloOfflineException', $.p4d);
    ApolloOfflineExceptionClass = $;
  }
  return ApolloOfflineExceptionClass;
}
var ApolloNetworkExceptionClass;
function ApolloNetworkException() {
  if (ApolloNetworkExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message, platformCause) {
        return new.target.e47(message, platformCause);
      }
      static e47(message, platformCause) {
        message = message === VOID ? null : message;
        platformCause = platformCause === VOID ? null : platformCause;
        var $this = this.k4d(message, platformCause instanceof Error ? platformCause : null);
        captureStack($this, $this.d47_1);
        $this.c47_1 = platformCause;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloNetworkException', $.e47);
    ApolloNetworkExceptionClass = $;
  }
  return ApolloNetworkExceptionClass;
}
var ApolloWebSocketClosedExceptionClass;
function ApolloWebSocketClosedException() {
  if (ApolloWebSocketClosedExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(code, reason, cause) {
        return new.target.w4d(code, reason, cause);
      }
      static w4d(code, reason, cause) {
        reason = reason === VOID ? null : reason;
        cause = cause === VOID ? null : cause;
        var $this = this.k4d("WebSocket Closed code='" + code + "' reason='" + reason + "'", cause);
        captureStack($this, $this.v4d_1);
        $this.t4d_1 = code;
        $this.u4d_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloWebSocketClosedException');
    ApolloWebSocketClosedExceptionClass = $;
  }
  return ApolloWebSocketClosedExceptionClass;
}
var ApolloGraphQLExceptionClass;
function ApolloGraphQLException() {
  if (ApolloGraphQLExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(error) {
        return new.target.x42(error);
      }
      static x42(error) {
        var $this = this.k4d("GraphQL error: '" + error.j46_1 + "'");
        captureStack($this, $this.w42_1);
        $this.u42_1 = error;
        $this.v42_1 = listOf($this.u42_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloGraphQLException');
    ApolloGraphQLExceptionClass = $;
  }
  return ApolloGraphQLExceptionClass;
}
var DefaultApolloExceptionClass;
function DefaultApolloException() {
  if (DefaultApolloExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message, cause) {
        return new.target.q42(message, cause);
      }
      static q42(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.k4d(message, cause);
        captureStack($this, $this.p42_1);
        return $this;
      }
    }
    initMetadataForClass($, 'DefaultApolloException', $.q42);
    DefaultApolloExceptionClass = $;
  }
  return DefaultApolloExceptionClass;
}
var NoDataExceptionClass;
function NoDataException() {
  if (NoDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(cause) {
        return new.target.d43(cause);
      }
      static d43(cause) {
        var $this = this.k4d('No data was found', cause);
        captureStack($this, $this.c43_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NoDataException');
    NoDataExceptionClass = $;
  }
  return NoDataExceptionClass;
}
var JsonDataExceptionClass;
function JsonDataException() {
  if (JsonDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message) {
        return new.target.y46(message);
      }
      static y46(message) {
        var $this = this.k4d(message);
        captureStack($this, $this.x46_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDataException');
    JsonDataExceptionClass = $;
  }
  return JsonDataExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message) {
        return new.target.o4c(message);
      }
      static o4c(message) {
        var $this = this.k4d(message);
        captureStack($this, $this.n4c_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
var ApolloHttpExceptionClass;
function ApolloHttpException() {
  if (ApolloHttpExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(statusCode, headers, body, message, cause) {
        return new.target.e4e(statusCode, headers, body, message, cause);
      }
      static e4e(statusCode, headers, body, message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.k4d(message, cause);
        captureStack($this, $this.d4e_1);
        $this.a4e_1 = statusCode;
        $this.b4e_1 = headers;
        $this.c4e_1 = body;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloHttpException');
    ApolloHttpExceptionClass = $;
  }
  return ApolloHttpExceptionClass;
}
var RouterErrorClass;
function RouterError() {
  if (RouterErrorClass === VOID) {
    class $ extends ApolloException() {
      constructor(errors) {
        return new.target.k4e(errors);
      }
      static k4e(errors) {
        var tmp0_safe_receiver = firstOrNull(errors);
        var $this = this.k4d("Router error(s) (first: '" + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j46_1) + "')");
        captureStack($this, $this.j4e_1);
        $this.i4e_1 = errors;
        return $this;
      }
    }
    initMetadataForClass($, 'RouterError');
    RouterErrorClass = $;
  }
  return RouterErrorClass;
}
var SubscriptionOperationExceptionClass;
function SubscriptionOperationException() {
  if (SubscriptionOperationExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(operationName, payload) {
        return new.target.q4e(operationName, payload);
      }
      static q4e(operationName, payload) {
        var $this = this.k4d('Operation error ' + operationName);
        captureStack($this, $this.p4e_1);
        $this.o4e_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionOperationException');
    SubscriptionOperationExceptionClass = $;
  }
  return SubscriptionOperationExceptionClass;
}
var SubscriptionConnectionExceptionClass;
function SubscriptionConnectionException() {
  if (SubscriptionConnectionExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(payload) {
        return new.target.w4e(payload);
      }
      static w4e(payload) {
        var $this = this.k4d('Subscription connection error');
        captureStack($this, $this.v4e_1);
        $this.u4e_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionConnectionException');
    SubscriptionConnectionExceptionClass = $;
  }
  return SubscriptionConnectionExceptionClass;
}
var NullOrMissingFieldClass;
function NullOrMissingField() {
  if (NullOrMissingFieldClass === VOID) {
    class $ extends ApolloException() {
      constructor(message) {
        return new.target.i43(message);
      }
      static i43(message) {
        var $this = this.k4d(message);
        captureStack($this, $this.h43_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NullOrMissingField');
    NullOrMissingFieldClass = $;
  }
  return NullOrMissingFieldClass;
}
//region block: exports
export {
  ApolloException as ApolloException16lek20l78zc3,
  ApolloGraphQLException as ApolloGraphQLException2qazyzs4ebcad,
  ApolloHttpException as ApolloHttpException3o30u8ntkffuh,
  ApolloNetworkException as ApolloNetworkException3denf70pfh242,
  ApolloOfflineException as ApolloOfflineException3onq1f2zlyouj,
  ApolloWebSocketClosedException as ApolloWebSocketClosedException26hvn543pf46i,
  DefaultApolloException as DefaultApolloException8w3ielfxng0h,
  JsonDataException as JsonDataException2rdtm884tky1l,
  JsonEncodingException as JsonEncodingException1gbe1fu68vssf,
  NoDataException as NoDataException34qvcinicy2ih,
  NullOrMissingField as NullOrMissingField1bkks6typ2v8h,
  RouterError as RouterError3i6hxcnqsy5l3,
  SubscriptionConnectionException as SubscriptionConnectionException12fjxvnnqzby5,
  SubscriptionOperationException as SubscriptionOperationException3t8cqqpx8bt9j,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
